<template>
  <v-container class="mt-10">
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onLogin" class="ml-4 mr-4 mb-3">
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="username"
                      :label="$t('login.username')"
                      id="username"
                      v-model="username"
                      type="text"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                      name="password"
                      :type="show ? 'text' : 'password'"
                      :label="$t('login.password')"
                      id="password"
                      v-model="password"
                      required
                      :append-icon="show ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="show = !show"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex xs12>
                    <v-btn block class="primary" type="submit" :disabled="loading" :loading="loading">
                      <v-icon dark left>exit_to_app</v-icon>
                      {{ $t('login.signin') }}
                    </v-btn>
                  </v-flex>
                </v-layout>

                <v-layout row class="mt-3">
                  <v-divider class="mt-3 mr-2 ml-3"></v-divider>or
                  <v-divider class="mt-3 mr-3 ml-2"></v-divider>
                </v-layout>

                <v-layout row class="mt-3">
                  <v-flex xs12>
                    <v-btn block :disable="loading" @click="onMicrosoftLogin()">
                      <v-img src="img/microsoft.png" max-width="20" max-height="20" class="mr-2"></v-img>
                      {{ $t('login.microsoft') }}
                    </v-btn>
                  </v-flex>
                </v-layout>
              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Vue from "vue";

export default {
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      show: false
    };
  },
  computed: {
    ...mapGetters(["getLoggedIn"])
  },
  watch: {
    getLoggedIn(value) {
      if (value) {
        this.mShowLongLoader(this.$i18n.t("common.pleasewait"));
        this.$router.push({ name: "home" });
      }
    }
  },
  methods: {
    ...mapActions(["doLogin"]),
    ...mapMutations(["mShowLongLoader", "mShowErrorMessage"]),
    async onLogin() {
      this.$log.debug(this.$vuetify);
      this.loading = true;
      try {
        await this.doLogin({
          username: this.username,
          password: this.password
        });
      } catch (err) {
        this.mShowErrorMessage(this.$i18n.t('err.login'))
      }
      Vue.$startIoTSignalR();
      Vue.$startUsersSignalR();
      this.loading = false;
    },
    async onMicrosoftLogin() {
      location.href = Vue.$url(`login/microsoft`);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.commit("mLogout");
    });
  }
};
</script>